<template>
  <section>
    <div class="card">
      <div class="leaderboard">
        <p class="card-title"> Ventes jour de mon équipe</p>
        <div class="leaderboard-inner">
          <b-loading
            :is-full-page="false"
            :active.sync="isLoading"
            :can-cancel="true"
          ></b-loading>

          <b-select
            placeholder="Choisir le"
            v-model="sortMode"
            @input="sortUsers()"
          >
            <option value="0">Tri en Ventes/Jour</option>
            <option value="1">Tri par Ventes aujourd'hui</option>
          </b-select>

          <ve-histogram
            class="graph"
            :data="chartData"
            :settings="chartSettings"
          >
          </ve-histogram>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VeHistogram from "v-charts/lib/histogram.common";

export default {
  name: "leaderBoard",
  components: { "ve-histogram": VeHistogram },
  props: ["sales", "users", "isAdmin"],

  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      myData: [],
      avatars: [],
      chartSettings: {
        metrics: ["Moyenne", "Aujourd'hui"]
      },
      chartData: {
        columns: ["vendeur", "Moyenne", "Aujourd'hui"],
        rows: []
      },
      sortMode: 0
    };
  },
  watch: {
    sales: function(newVal, oldVal) {
      this.sortUsers();
      this.isLoading = this.chartData.rows.length == 0;
    }
  },
  methods: {
    sortUsers() {
      var salesPerUser = [];
      for (var i = 0; i < this.users.length; i++) {
        if (
          this.isAdmin ||
          this.users[i].weezy_id == this.$store.state.weezy_id
        ) {
          var totalUserSales = [];
          var lastGoalSales = [];
          var todaySales = [];
          var days = [];
          for (var j = 0; j < this.sales.length; j++) {
            if (this.sales[j].user_id == this.users[i].id) {
              totalUserSales.push(this.sales[j]);
              if (
                new Date(this.sales[j].creation_date_time) >=
                new Date().setHours(0, 0, 0, 0)
              ) {
                todaySales.push(this.sales[j]);
              }
            }
          }

          for (var k = 0; k < totalUserSales.length; k++) {
            var saleDate = new Date(totalUserSales[k].creation_date_time);
            var formattedDate =
              saleDate.getDay() +
              "/" +
              saleDate.getMonth() +
              "/" +
              saleDate.getFullYear();
            if (!days.includes(formattedDate)) {
              days.push(formattedDate);
            }
          }

          salesPerUser.push({
            vendeur: this.getDisplayName(this.getUser(this.users[i].id)),
            Moyenne: totalUserSales.length / Math.max(1, days.length), // divide by days
            "Aujourd'hui": todaySales.length
          });

          if (this.sortMode == 1) {
            salesPerUser.sort((a, b) => b["Aujourd'hui"] - a["Aujourd'hui"]);
          } else {
            salesPerUser.sort((a, b) => b.Moyenne - a.Moyenne);
          }
        }
      }
      this.chartData.rows = salesPerUser;
    },
    getUser(forId) {
      var user = undefined;
      for (var i = 0; i < this.users.length; i++) {
        if (forId == this.users[i].id) {
          user = this.users[i];
          break;
        }
      }
      return user;
    },
    getDisplayName(user) {
      let display = "";
      var str = "";
      if (user.name)
        str =
          user.name
            .replace("-", "")
            .replace(" ", "")
            .substring(0, 5) + "\n";

      if (user.surname)
        str += user.surname
          .replace("-", "")
          .replace(" ", "")
          .substring(0, 5);
      return str;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media screen and (max-width: 768px) {
  .card {
    padding-left: 4px;
    padding-right: 4px;
    overflow: hidden;
  }

  .graph {
    margin-top: 10px !important;
  }

  .leaderboard-inner {
    margin: 25px 0 0 0;
  }
}

@media screen and (min-width: 768px) {
  .card {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    .leaderboard-inner {
      margin: 25px 10px;
    }
  }
}

.leaderboard-inner {
  text-align: center !important;
}

.card {
  box-shadow: none;

  .control {
    text-align: center;
  }
}

body {
  padding-left: 30px;
}
.b-text-field {
  width: 150px;
}

.leaderboard {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding-bottom: 10px;
}

.graph {
  margin-bottom: -60px !important;
}

.loading-overlay {
  padding-right: 20px;
}
</style>